























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { PointList } from '@/models/point/list/point'
import PointRow from './PointRow.vue'
import TableCell from './TableCell.vue'
import TableRow from './TableRow.vue'

@Component({
  components: { TableRow, TableCell, PointRow },
})
export default class PointTable extends Vue {
  @Prop({ required: true })
  points: PointList

  pointRowClass(index: number): string[] {
    const base = [
      'point-table-row',
    ]

    // 有効期限切れが直近のものは表示調整
    return index === 0
      ? [...base, 'emphasized']
      : base
  }
}
